"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class CustomLogger {
    // Initialize the SDK with envKey and appVersion
    static init(envKey, appVersion) {
        if (!envKey || !appVersion) {
            console.error("Environment key and app version must be provided.");
            return;
        }
        this.envKey = envKey;
        this.appVersion = appVersion;
        if (typeof window !== "undefined") {
            // Browser environment
            window.addEventListener("error", (event) => {
                this.logError(event.error);
            });
            window.addEventListener("unhandledrejection", (event) => {
                const reason = event.reason;
                if (reason instanceof Error) {
                    this.logError(reason);
                }
                else {
                    this.logError(new Error(String(reason)));
                }
            });
        }
        else if (typeof process !== "undefined") {
            // Node.js environment
            process.on("uncaughtException", (error) => {
                this.logError(error);
            });
            process.on("unhandledRejection", (reason) => {
                if (reason instanceof Error) {
                    this.logError(reason);
                }
                else {
                    this.logError(new Error(String(reason)));
                }
            });
        }
    }
    // Send error details to the endpoint, including app version
    static sendErrorToEndpoint(errorDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.envKey || !this.appVersion) {
                console.error("Environment key and app version must be initialized.");
                return;
            }
            try {
                const payload = Object.assign(Object.assign({}, errorDetails), { appVersion: this.appVersion }); // Add appVersion to the payload
                // Check environment and send error accordingly
                if (typeof window !== "undefined") {
                    // Browser environment
                    yield fetch(this.endpoint, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Env-key": this.envKey,
                        },
                        body: JSON.stringify(payload),
                    });
                }
                else if (typeof process !== "undefined") {
                    // Node.js environment
                    const https = yield Promise.resolve().then(() => __importStar(require("node:https")));
                    const data = JSON.stringify(payload);
                    const options = {
                        hostname: "api.retack.ai",
                        port: 443,
                        path: "/observe/error-log/",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Env-key": this.envKey,
                        },
                    };
                    const req = https.request(options, (res) => {
                        res.on("data", (chunk) => {
                            console.log(`Response: ${chunk}`);
                        });
                    });
                    req.on("error", (error) => {
                        console.error("Failed to send error to endpoint:", error);
                    });
                    req.write(data);
                    req.end();
                }
            }
            catch (error) {
                console.error("Failed to send error to endpoint:", error);
            }
        });
    }
    // Log error and send with app version
    static logError(error) {
        if (!this.envKey || !this.appVersion) {
            console.error("Environment key and app version must be initialized.");
            return;
        }
        const errorPayload = {
            title: error.name,
            stack_trace: error.stack, // Fix stack_trace to match interface
            versions: this.appVersion, // Use appVersion correctly
        };
        this.sendErrorToEndpoint(errorPayload);
    }
}
CustomLogger.endpoint = "https://api.retack.ai/observe/error-log/";
CustomLogger.envKey = null;
CustomLogger.appVersion = null; // Store the app version
exports.default = CustomLogger;
